// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"74395d13","239":"a19c5b78","453":"c7babd3d","732":"eaf0456d"}[chunkId] + ".chunk.js";
};